<template>
  <div class="k-search">
    <div
      class="search-container"
      @click="isOpened = !isOpened"
      @focusout="handleFocusOut"
    >
      <input
        type="text"
        class="search-input"
        :aria-placeholder="placeholder"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        @keyup.enter="$emit('search')"
      />
      <button
        class="search-button"
        @click="$emit('search')"
      >
        <k-icon
          icon="search1"
          class="icon"
        />
      </button>
    </div>
    <transition name="slide-down">
      <div
        class="search-results"
        v-if="isOpened && results && filteredResults.length > 0"
      >
        <h3 class="title">
          {{ results.title }}
        </h3>
        <ul class="results-list">
          <li
            class="results-item"
            v-for="(result, index) in filteredResults"
            :key="`result-${index}`"
            @click="clickSuggestion(result.name)"
          >
            <button
              class="search-suggestion"
              @click="clickSuggestion(result.name)"
            >
              {{result.name}}
            </button>
            <button
              class="close-button"
              @click="$emit('remove-item', result)"
            >
              <k-icon
                icon="close"
                class="close"
              />
            </button>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import KIcon from './KIcon.vue'

export default {
  name: 'KSearch',
  components: {
    KIcon
  },
  props: {
    placeholder: {
      type: String,
      default: 'O que você precisa hoje?'
    },
    results: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      isOpened: false
    }
  },
  methods: {
    handleCLick (term) {
      this.$emit('clickSuggestion', term)
    },
    clickSuggestion (term) {
      this.isOpened = false
      this.$emit('click-suggestion', term)
    },
    handleFocusOut () {
      if (this.isOpened) this.isOpened = false
    },
    improveResults (text) {
      const removeAccent = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return removeAccent.toLowerCase()
    }
  },
  computed: {
    filteredResults () {
      const searchTerm = this.$attrs.value
      const results = this.results.results.filter((result) => this.improveResults(result.name).indexOf(this.improveResults(searchTerm)) !== -1)
      return results
    }
  }
};
</script>

<style lang='scss'>
@import "../assets/scss/main.scss";

.k-search {
  width: 100%;
  max-width: 500px;
  position: relative;
  .search-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    background: white;
    border-radius: 10px;
    box-shadow: 2px 8px 16px 0 rgba(24, 50, 115, 0.06);
    padding: $spacing-xxs;
    margin-bottom: $spacing-xs;
    .search-input {
      width: 100%;
      padding: 13px;
      border: none;
      outline: none;
    }
    .search-button {
      width: 40px;
      height: 40px;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      color: $primary-3;
      background: $category-3;
      .icon {
        font-size: 24px;
      }
    }
  }

  .search-results {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    z-index: 100;
    background: white;
    border-radius: 10px;
    box-shadow: 2px 8px 16px 0 rgba(24, 50, 115, 0.06);
    padding: $spacing-m $spacing-xs $spacing-xs $spacing-xs;
    .title {
      text-align: left;
      margin: 0;
      padding-left: $spacing-s;
      padding-right: $spacing-s;
      @include heading-4;
      color: rgba($neutral-1, 0.8);
    }
    .results-list {
      list-style: none;
      margin: 0px;
      padding: 0;
      .results-item {
        text-align: left;
        padding: $spacing-s;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 4px;
        transition: all ease 0.3s;
        @include body-3;
        cursor: pointer;
        outline: none;
        .search-suggestion {
          width: 100%;
          text-align: left;
          padding: 0;
          background: none;
          border: none;
          cursor: pointer;
          color: rgba($neutral-1, 0.6);
        }
        &:hover,
        &:focus {
          background: rgba(32, 41, 80, 0.03);
          .search-suggestion {
            color: $neutral-1;
          }
        }
        .close-button {
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
          .close {
            color: rgba($neutral-1, 0.3);
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/KSearch.vue